/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-section[_ngcontent-%COMP%]{padding:1em 2em}.nsc-card[_ngcontent-%COMP%]{max-width:720px;margin:0 auto}.nsc-card__logo[_ngcontent-%COMP%]{max-width:250px;margin:0 auto;opacity:.65}.nsc-title[_ngcontent-%COMP%]{font:400 24px/32px Roboto,\"Helvetica Neue\",sans-serif;text-align:center}small[_ngcontent-%COMP%]{font-size:.9rem}img[_ngcontent-%COMP%]{width:100%;height:auto}p[_ngcontent-%COMP%]{margin:.5em}"];
export { styles as styles };
